import { type TranslationTree } from '@/i18n/types';

export const messages = {
  status: {
    pending_review: 'Conta em análise',
    approved: 'Conta aprovada',
    rejected: 'Conta recusada',
    suspended: 'Conta suspensa',
  },
} satisfies TranslationTree;
